cockpitApp.filter('normalizeSeatCharacteristic', function() {
  return function(seatCharacter) {
    if (seatCharacter !== undefined) {
      var lowCase = seatCharacter.toLowerCase().replace(/_/g, ' ');

      return lowCase[0].toUpperCase() + lowCase.slice(1);
    }
  }
});
